export const MENTION_LETTER_OFFSET = 24;

export const MENTIONS_REGEXP = /(?<mention>(@([^Q\s]+@\S+)))/g;
